import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader, PageDataFetcher } from '../../components'
import { PageContent } from './components'
import { fetchBlogs as fetcher, setQuery } from '../../features/blogs/slice'
import { useInternationalization } from '../../features/i18n/hook'
import * as pageConfig from './config'
import AudienceListener from '../../features/collection/components/audience-listener'
const { PAGE_IMAGE, STATE_KEY } = pageConfig

const Blog = (props) => {
  const { translate } = useInternationalization()

  return (
    <DefaultLayout>
      <AudienceListener />
      <PageDataFetcher
        stateKey={STATE_KEY}
        fetcher={fetcher}
        querySetter={setQuery}
        pageConfig={pageConfig}
        {...props}
      >
        <PageHeader
          title={translate('BLOG', 'singular')}
          description={translate('BLOG', 'page_description')}
          image={PAGE_IMAGE}
          className="pt-5 lg:pt-6 lg:pb-0"
        />
        <PageContent />
      </PageDataFetcher>
    </DefaultLayout>
  )
}

export { Blog }
